/**
 * Enterprise Edition specific banner components.
 *
 * If there is any problem with the installation activation, show the activation banner, otherwise
 * fall back to the core banner components.
 */

import { buildActivationBanner } from "app/client/components/ActivationBanner";
import * as CoreBanners from "app/client/components/CoreBanners";
import { createEnterpriseSpecificFunc } from "app/client/lib/enterpriseDeploymentCheck";
import { AppModel } from "app/client/models/AppModel";
import { DocPageModel } from "app/client/models/DocPageModel";

const EEBanners = {
  buildHomeBanners(app: AppModel) {
    return buildActivationBanner(app) || [
      CoreBanners.buildHomeBanners(app),
    ];
  },
  buildDocumentBanners(docPageModel: DocPageModel) {
    return buildActivationBanner(docPageModel.appModel) || [
      CoreBanners.buildDocumentBanners(docPageModel),
    ];
  },
};

export const buildHomeBanners = createEnterpriseSpecificFunc(
  EEBanners.buildHomeBanners,
  CoreBanners.buildHomeBanners,
);

export const buildDocumentBanners = createEnterpriseSpecificFunc(
  EEBanners.buildDocumentBanners,
  CoreBanners.buildDocumentBanners,
);
